module.exports = __webpack_public_path__ + "static/media/jboss-logo-2.a0accd05.png";